export default {
  en: {
    'components.messages.participant-selector.title': 'Add Participants',
    'components.messages.participant-selector.no-results': 'No matching users found.',
    'components.messages.participant-selector.add.empty': 'Select Participants',
    'components.messages.participant-selector.add.active':
      'Add {count, plural, one {# Participant} other {# Participants}}',
  },
};
